import React from 'react';
import { Skeleton } from 'antd';

const HeroSkeleton: React.FC = () => (
  <div
    style={{
      background: 'var(--bl-primary, #3390ec)',
      padding: '20px 16px 16px',
      marginBottom: 12,
    }}
  >
    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
      <div
        style={{
          flexShrink: 0,
          borderRadius: 16,
          border: '3px solid rgba(255,255,255,0.3)',
          overflow: 'hidden',
          lineHeight: 0,
          opacity: 0.5,
        }}
      >
        <Skeleton.Avatar active size={72} shape="square" style={{ borderRadius: 13, display: 'block' }} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <Skeleton
          active
          title={{ width: '70%', style: { height: 20, marginBottom: 8, borderRadius: 6 } }}
          paragraph={{ rows: 1, width: '45%', style: { height: 13 } }}
          style={{ opacity: 0.4 }}
        />
      </div>
    </div>
    <div style={{ marginTop: 12, display: 'flex', flexDirection: 'column', gap: 6, opacity: 0.4 }}>
      <Skeleton.Input active size="small" style={{ width: 160, height: 13, borderRadius: 4 }} />
      <Skeleton.Input active size="small" style={{ width: 120, height: 13, borderRadius: 4 }} />
    </div>
  </div>
);

const UpcomingCardSkeleton: React.FC = () => (
  <div
    style={{
      margin: '0 16px 12px',
      borderRadius: 16,
      background: 'var(--bl-surface, #fff)',
      border: '1px solid var(--bl-divider, rgba(0,0,0,0.08))',
      overflow: 'hidden',
      display: 'flex',
    }}
  >
    <div style={{ width: 4, background: 'var(--bl-divider, rgba(0,0,0,0.08))', flexShrink: 0 }} />
    <div style={{ flex: 1, padding: '13px 14px' }}>
      <Skeleton.Input active size="small" style={{ width: 100, height: 12, borderRadius: 4, marginBottom: 10 }} />
      <Skeleton
        active
        title={{ width: '65%', style: { height: 16, marginBottom: 6, borderRadius: 6 } }}
        paragraph={{ rows: 1, width: '40%', style: { height: 13 } }}
      />
      <Skeleton.Input active size="default" style={{ width: '100%', height: 38, borderRadius: 10, marginTop: 12 }} />
    </div>
  </div>
);

const ServiceItemSkeleton: React.FC = () => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      padding: '11px 12px',
      borderRadius: 12,
      background: 'var(--bl-surface-soft, rgba(16,24,40,0.04))',
    }}
  >
    <Skeleton.Avatar active size={34} shape="square" style={{ borderRadius: 8, flexShrink: 0 }} />
    <div style={{ flex: 1, minWidth: 0 }}>
      <Skeleton
        active
        title={{ width: '55%', style: { height: 15, marginBottom: 6, borderRadius: 5 } }}
        paragraph={{ rows: 1, width: '35%', style: { height: 12 } }}
      />
    </div>
    <Skeleton.Input active size="small" style={{ width: 52, height: 15, borderRadius: 4 }} />
  </div>
);

const ServicesPreviewSkeleton: React.FC = () => (
  <div
    style={{
      margin: '0 16px 12px',
      borderRadius: 16,
      background: 'var(--bl-surface, #fff)',
      border: '1px solid var(--bl-divider, rgba(0,0,0,0.08))',
      padding: '14px 16px',
    }}
  >
    <Skeleton.Input active size="small" style={{ width: 100, height: 17, borderRadius: 5, marginBottom: 14 }} />
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <ServiceItemSkeleton />
      <ServiceItemSkeleton />
      <ServiceItemSkeleton />
    </div>
  </div>
);

export const HomeScreenSkeleton: React.FC = () => (
  <div style={{ paddingBottom: 'calc(80px + env(safe-area-inset-bottom, 0px))' }}>
    <HeroSkeleton />
    <UpcomingCardSkeleton />
    <ServicesPreviewSkeleton />
  </div>
);
